var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Grid, GridItem, SimpleGrid as ChakraSimpleGrid, } from "@chakra-ui/react";
import { Spacing } from "../../core/constants";
/**
 * Friendly interface to create responsive grid layouts with ease. It renders a div element with display: grid.
 */
const SimpleGrid = forwardRef((_a, ref) => {
    var { className, spacing = Spacing[2], columns, children } = _a, rest = __rest(_a, ["className", "spacing", "columns", "children"]);
    return (React.createElement(ChakraSimpleGrid, Object.assign({}, rest, { ref: ref, className: className, spacing: spacing, columns: columns }), children));
});
SimpleGrid.displayName = "SimpleGrid";
export { Grid, GridItem };
export default SimpleGrid;
//# sourceMappingURL=Grid.js.map